
const Auth = {
    path: '/auth',
    isSection:  true,
    sub: {
        login: '/login',  
        logout: '/logout',  
        register: '/register',  
        currentUser: '/current',
        checkSignupData: '/check-signup-data',
    },
}

export default Auth;